import * as React from 'react';

export type IExpandProps = {
  startIndex: number;
  numHidden: number;
  expand: (expandIncrement: number) => void;
};

export function useExpand<T>(options: {
  items: T[];
  initialNumShown: number;
}): IExpandProps {
  const { items, initialNumShown } = options;
  const [numShown, setNumShown] = React.useState(initialNumShown);

  React.useEffect(() => {
    setNumShown((numShown) =>
      numShown > initialNumShown ? numShown : initialNumShown
    );
  }, [initialNumShown]);

  return numShown >= items.length
    ? {
        startIndex: 0,
        numHidden: 0,
        expand: () => null,
      }
    : {
        startIndex: items.length - numShown,
        numHidden: items.length - numShown,
        expand: (expandIncrement) =>
          setNumShown((currentNumShown) => currentNumShown + expandIncrement),
      };
}
